import { render, staticRenderFns } from "./productHaji.vue?vue&type=template&id=586098a2&"
import script from "./productHaji.vue?vue&type=script&lang=ts&"
export * from "./productHaji.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports